import { useEffect, useRef } from 'react';

export default function Marquee() {
  const marqueeRef = useRef(null);

  return (
    <div className="bg-primary text-white py-3 overflow-hidden" data-testid="marquee-announcement">
      <div className="animate-marquee whitespace-nowrap" ref={marqueeRef}>
        <span className="text-sm font-medium tracking-wide uppercase inline-block px-8">
          Nursing Care Facilities Available in Tricity | Free Consultation for Police Officers and Army Personnel     |First Counsultation Free | National & International Online Consultation Available
        </span>
        <span className="text-sm font-medium tracking-wide uppercase inline-block px-8">
          Nursing Care Facilities Available in Tricity | Free Consultation for Police Officers and Army Personnel     |First Counsultation Free | National & International Online Consultation Available
        </span>
      </div>
    </div>
  );
}

/* Add this to index.css:
@keyframes marquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.animate-marquee {
  animation: marquee 30s linear infinite;
}
*/